<template>
  <div
    class="tw:rounded-xl tw:p-4 tw:transition-all tw:duration-300 tw:cursor-pointer tw:shadow-lg"
    :class="{ 'tw:border-blue-700 tw:border-2': isSelected }"
    :data-testid="`pause-flow-radio-${value}`"
    @click="handleChange"
  >
    <div class="tw:flex tw:items-center tw:gap-x-4 tw:mb-0">
      <input
        :id="inputId"
        type="radio"
        :value="value"
        :name="label"
        :aria-labelledby="`${inputId}-label`"
        :checked="isSelected"
        @change="handleChange"
        @click.stop
      />

      <span class="radio-custom"></span>
      <label :id="`${inputId}-label`" :for="inputId" class="tw:text-gray-800 tw:font-bold tw:mb-0">{{ label }}</label>
    </div>

    <div
      class="tw:grid tw:transition-all tw:duration-500 tw:ease-in-out"
      :class="isSelected ? 'tw:grid-rows-[1fr] tw:opacity-100' : 'tw:grid-rows-[0fr] tw:opacity-0'"
    >
      <div class="tw:overflow-hidden">
        <div class="tw:mt-4">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  selectedValue: String,
  value: String,
  label: String,
})

const emit = defineEmits(['select'])

const isSelected = computed(() => props.selectedValue === props.value)
const inputId = computed(() => `pause-flow-radio-${props.value}`)

const handleChange = () => {
  emit('select', props.value)
}
</script>
